import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker } from '@skbkontur/react-ui';
import { ValidationWrapper } from '@skbkontur/react-ui-validations';
import { convertDatePickerToISO, convertISOToDatePicker } from '../../helpers/convertDate';
export const DatePickerISO = ({ value, onValueChange, validationInfo, renderMessage, minDate = '', maxDate = '', width, ...rest }) => {
    const handleValueChange = (value) => {
        if (onValueChange) {
            onValueChange(convertDatePickerToISO(value));
        }
    };
    return (_jsx(ValidationWrapper, { validationInfo: validationInfo, renderMessage: renderMessage, children: _jsx(DatePicker, { width: width || 132, onValueChange: handleValueChange, minDate: convertISOToDatePicker(minDate) || undefined, maxDate: convertISOToDatePicker(maxDate) || undefined, value: convertISOToDatePicker(value || ''), ...rest }) }));
};
